import { AbsoluteFill, useCurrentFrame, useVideoConfig } from "remotion";
import React from "react";

// VFX: Story Progress Bars
// Category: card-animations · Tags: ui, story, progress, instagram, segments
const StoryProgress: React.FC<{
  totalSlides?: number; currentSlide?: number; accentColor?: string;
}> = ({ totalSlides = 5, currentSlide = 2, accentColor = "#fff" }) => {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const currentProgress = (frame % durationInFrames) / durationInFrames;
  return (
    <AbsoluteFill style={{ justifyContent: "flex-start", padding: "32px 16px 0" }}>
      <div style={{ display: "flex", gap: 6, width: "100%" }}>
        {Array.from({ length: totalSlides }, (_, i) => {
          const fill = i < currentSlide ? 1 : i === currentSlide ? currentProgress : 0;
          return (
            <div key={i} style={{ flex: 1, height: 4, background: "rgba(255,255,255,0.3)", borderRadius: 2, overflow: "hidden" }}>
              <div style={{ height: "100%", width: `${fill * 100}%`, background: accentColor, borderRadius: 2 }} />
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

export default function UiStoryProgressBarsLoop() {
  return (
    <AbsoluteFill style={{ background: "linear-gradient(135deg, #1e293b 0%, #0a0e1a 100%)" }}>
      <StoryProgress totalSlides={5} currentSlide={2} />
      <AbsoluteFill style={{ alignItems: "center", justifyContent: "center" }}>
        <span style={{ color: "#94a3b8", fontSize: 28, fontWeight: 600 }}>Story Content</span>
      </AbsoluteFill>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
